import {
  RadialBarChart, RadialBar
} from "recharts";

export function GaugeChart({ pct, C }) {
  const clamped = Math.min(pct, 200);
  const color = pct > 100 ? "#EF4444" : pct >= 90 ? "#10B981" : "#F59E0B";
  const data = [{ value: clamped, fill: color }];
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <RadialBarChart
        width={220} height={205}
        cx={110} cy={115}
        innerRadius={70} outerRadius={105}
        startAngle={180} endAngle={0}
        data={data} barSize={18}
      >
        <RadialBar dataKey="value" cornerRadius={6}
          background={{ fill: C.border }} />
      </RadialBarChart>
      <div style={{ marginTop: -28, textAlign: "center" }}>
        <p style={{ fontSize: 26, fontWeight: 900, color, margin: 0 }}>{pct.toFixed(1)}%</p>
        <p style={{ fontSize: 10, color: C.muted, margin: "2px 0 0" }}>Realizado / Planejado</p>
      </div>
      <div style={{ display: "flex", gap: 16, marginTop: 10 }}>
        {[
          { label: "Abaixo do esperado", color: "#F59E0B" },
          { label: "No alvo", color: "#10B981" },
          { label: "Acima do planejado", color: "#EF4444" },
        ].map((l) => (
          <div key={l.label} style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <div style={{ width: 8, height: 8, borderRadius: "50%", background: l.color }} />
            <span style={{ fontSize: 10, color: C.muted }}>{l.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}